

















































































import { LeadCommand, LeadService } from "@/services/lead.service";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { required } from "@/shared/validators";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ComboCanalLead from "../components/ComboCanalLead.vue";
import ComboTipoLead from "../components/ComboTipoLead.vue";
import ComboEtapaLead from "../components/ComboEtapaLead.vue";
import ComboStatusLead from "../components/ComboStatusLead.vue";

const cleanedLeadCommand = {
  idStatusLead: 1,
    idEtapaLead: 0,
} as LeadCommand;

@Component({
  components: { Modal, ComboTipoLead, ComboCanalLead, ComboEtapaLead, ComboStatusLead },
})
export default class AdicionarLead extends mixins(GlobalMixin) {
  loading = false;
  lead: LeadCommand = {
    idStatusLead: 1,
    idEtapaLead: 0,
  } as LeadCommand;
  novoCanal: string | null = null;
  telefone = "";

  rules = {
    nome: [required()],
    telefone: [required()],
    canalProspeccao: [required()],
    idTipoLead: [required()],
    canalLead: [required()],
    idEtapaLead: [required()],
    idStatusLead: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async adicionarLead() {
    const modal = this.$refs.modal as Modal;
    this.lead = Object.assign({}, cleanedLeadCommand);
    const p = modal.open();

    return p;
  }

  async salvarNovoLead() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      try {
        if (this.lead) {
          this.lead.telefone = +this.telefone!.replace(/([^\d])+/gim, "");
          await LeadService.cadastrarLead(this.lead);
        }
        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
